// Slug helpers ported verbatim from web/public/app.js so URLs/run-directories
// keep matching the legacy behavior. Each helper has a clear single purpose;
// callers chain them as needed.

export function deriveSlugFromUrl(url: string): string {
  try {
    const host = new URL(url).hostname.replace(/^www\./, "");
    return (
      host
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "_")
        .replace(/_+/g, "_")
        .replace(/^_|_$/g, "") || "unternehmen"
    );
  } catch {
    return "unternehmen";
  }
}

export function deriveSlugFromText(text: string): string | null {
  if (!text) return null;
  const slug = text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_|_$/g, "")
    .slice(0, 40);
  return slug || null;
}

export function companySlugFromName(name: string): string {
  return (
    name
      .toLowerCase()
      .replace(/ä/g, "ae")
      .replace(/ö/g, "oe")
      .replace(/ü/g, "ue")
      .replace(/ß/g, "ss")
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_|_$/g, "") || "unternehmen"
  );
}

export function defaultSlugFromDate(): string {
  return "bericht_" + new Date().toISOString().slice(0, 10).replace(/-/g, "");
}

/**
 * Try a list of slug candidates, retrying the whole round if all fail.
 * Returns the resolved slug on success so the caller can update its state.
 */
export async function fetchWithSlugFallback(
  slugs: (string | null | undefined)[],
  buildUrl: (slug: string) => string,
  retries = 1,
  delayMs = 1500,
): Promise<{ response: Response | null; slug: string | null }> {
  const candidates = [...new Set(slugs.filter((s): s is string => Boolean(s)))];
  for (let attempt = 0; attempt < retries; attempt++) {
    for (const slug of candidates) {
      try {
        const r = await fetch(buildUrl(encodeURIComponent(slug)));
        if (r.ok) return { response: r, slug };
      } catch {
        // network blip: try next candidate / retry
      }
    }
    if (attempt < retries - 1) await new Promise((res) => setTimeout(res, delayMs));
  }
  return { response: null, slug: null };
}
